export enum DeliveryPartnersConfigurationTypeEnum {
  clientId = 'Uber Eats Client Id',
  clientSecret = 'Uber Eats Client Secret',
  locationId = 'Uber Eats Location Id',
  uberEatsMenu = 'Uber Eats Menu',
  uberEatsClientId = 'Uber Eats Client Id',
  uberEatsClientSecret = 'Uber Eats Client Secret',
  uberEatsLocationId = 'Uber Eats Location Id',
  justEatCollectionMenu = 'Just Eat Collection Menu',
  justEatDeliveryMenu = 'Just Eat Delivery Menu',
  justEatAPIKey = 'Just Eat API Key',
  justEatLocationReferenceId = 'Just Eat Location Reference Id',
  justEatVendorName = 'Just Eat Vendor Name',
  justEatUpCoAPIKey = 'Just Eat UpCo API Key',
  justEatPOSIDMerchantId = 'Just Eat POSID MerchantID', // used on API
  justEatAPIVersion = 'Just Eat API version', // used on API
  deliverooMenu = 'Deliveroo Menu',
  deliverooAPIKey = 'Deliveroo API Key',
  deliverooAPIToken = 'Deliveroo API Token',
  deliverooLocationReferenceId = 'Deliveroo Location Reference Id',
  deliverooBrandName = 'Deliveroo Brand Name',
  gigableApplicationSources = 'Gigable Application Sources'
}
